module.exports = __webpack_public_path__ + "img/018-south-korea.bfd22d0a.svg";